import find from 'lodash/find';
import { useEffect, useState } from 'react';
import type { ITicketsController } from '../lib/widget/tickets/tickets.interface';
import { useInjection } from 'inversify-react';
import { TICKETS_MODULE_IDS } from '../lib/widget/tickets/tickets.types';

const useSeat = ({ ticket }) => {
  const ticketsController: ITicketsController = useInjection(TICKETS_MODULE_IDS.TICKETS_CONTROLLER);

  const initialSelected = () =>
    !!find(ticketsController.selectedTickets, (item) => item.id === ticket.id);
  const updateSelectedTickets = () => {
    toggleSelected(initialSelected());
  };

  const [selected, toggleSelected] = useState(initialSelected());

  useEffect(() => {
    ticketsController.addListener(ticketsController.events.REMOVE, updateSelectedTickets);
    ticketsController.addListener(ticketsController.events.RENDER_TICKETS, updateSelectedTickets);

    return () =>
      ticketsController.removeListener(ticketsController.events.REMOVE, updateSelectedTickets);
  }, []);

  return { selected, toggleSelected };
};

export default useSeat;
